module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtit"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("L"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("IST OF")]), _vm._v(" P"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("HOTOS AND")]), _vm._v(" I"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("LLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter1#figure_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 1st New York Light Artillery")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter1#figure_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A troop transport ship arriving in New Orleans")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter1#figure_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The City Belle")]), _vm._v(" alongside the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Calypso")])])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter1#figure_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederate troops attacking a Union gunboat during the Red River Campaign")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Union Prisoners at Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Federhen’s sketch of the stockade and mud houses at Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prisoners and accommodations at Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scenes from Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The sutler’s store at Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter4#figure_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Federhen’s sketch of his quarters at Camp Ford")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter7#figure_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hounds chasing escaping Union prisoners in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter12#figure_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James G. Bourland")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter15#figure_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry E. McCulloch")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter17#figure_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A settler’s hut on the Red River in Texas")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter18#figure_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Clarke Quantrill")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter19#figure_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloody Bill Anderson")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter35#figure_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas W. Sherman")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Chapter36#figure_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ormand F. Nims")])]), _vm._v(" "), _c('p', {
    staticClass: "fmp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Postscript#figure_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oscar Federhen’s grave")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57fe887f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_List_of_photos.vue
// module id = 75
// module chunks = 0